<template>
  <div class="flux-fondos-step">
    <div class="flux-fondos-step__msg">{{ $t("guest.funds.actionOutside") }}</div>

    <div class="flux-fondos-metod">
      <div
        class="flux-fondos-metod__item flux-fondos-metod__item--paypal"
        v-show="paymentMethod == '3'"
      >
        <img
          class="flux-fondos-metod__logo"
          src="../../../assets/img/logos/logo-ico-paypal-full.svg"
          alt=""
        />
        <a :href="paymentData" target="_blank">
          <div class="button button--secondary">{{ $t("guest.funds.paypalInstructions") }}</div>
        </a>
      </div>
      <div
        class="flux-fondos-metod__item flux-fondos-metod__item--bizum"
        v-show="paymentMethod == '1'"
      >
        <img
          class="flux-fondos-metod__logo"
          src="../../../assets/img/logos/logo-ico-bizum-full.svg"
          alt=""
        />
        <div class="flux-fondos-metod__number" v-text="paymentData"></div>
        <div class="flux-fondos-metod__description">
          {{ $t("guest.funds.bizumInstructions") }}
        </div>
      </div>
      <div
        class="flux-fondos-metod__item flux-fondos-metod__item--bizum"
        v-show="paymentMethod == '2'"
      >
        <!-- <img
          class="flux-fondos-metod__logo"
          src="../../../assets/img/logos/logo-ico-bizum-full.svg"
          alt=""
        /> -->
        <div class="flux-fondos-metod__bank-account" v-text="paymentData"></div>
        <div class="flux-fondos-metod__description">
          {{ $t("guest.funds.bankTransferInstructions") }}
        </div>
      </div>
    </div>

    <div class="flux-fondos-step__msg flux-fondos-step__msg--mb">
      {{ $t("guest.funds.actionMessage", {name: list.ownerName}) }}
    </div>

    <div class="flux-fondos-step__actions">
      <loading-button v-if="loading"></loading-button>
      <button v-else class="button button--primary button--block" @click="$emit('finish')">{{ $t("guest.funds.actionDone") }}</button>
    </div>

  </div>
</template>
<script>
import LoadingButton from "../../../components/LoadingButton";

export default {
  name: "FluxFondosClassicStep3",
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    fund: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: Number,
      required: false
    },
    paymentName: {
      type: String,
      required: false
    },
    paymentData: {
      type: String,
      required: false
    },
    list: {
      type: Object,
      required: true
    }
  },
  //props: [ 'paymentMethod', 'fund', 'loading' ],
  components: {
    'loading-button': LoadingButton
  },
  computed: {
    bizumPhone() {
      // 2 BIZUM
      return this.getInfo(2)
    },
    paypalLink() {
      // 1 Paypal
      //alert(this.getInfo(2));
      var payPalLink = this.getInfo(1);
      if(!payPalLink.startsWith("https://") && !payPalLink.startsWith("http://"))
      {
        return "https://" + payPalLink;
      }
      else
      {
        return payPalLink;
      }
    }
  },
  methods: {
    getInfo(fundPaymentTypeId) {
      const found = this.fund.fundPaymentTypes.find(paymentType => paymentType.fundPaymentTypeId === fundPaymentTypeId)
      if (found) 
      {
        return found.info
      }
      return ''
    }
  }
};
</script>
